enum GameRule {
  Normal = "normal",
  Bomb = "bomb",
  Hard = "hard",
  Insane = "insane"
}

export default GameRule;
